import {Injectable} from "@angular/core";
import {Observable} from "rxjs/Observable";
import "rxjs/add/operator/map";
import "rxjs/add/operator/catch";
import "rxjs/add/observable/throw";
import {DataConfig} from "../../config";
import {HttpClient, HttpHeaders, HttpParams, HttpResponse} from "@angular/common/http";


@Injectable()
export class RestApiCall {


  constructor(private http: HttpClient) {
  }

  getParams() {
    return new URLSearchParams();
  }

  getURLSearchParams(): HttpParams {
    return new HttpParams();
  }


  /**
   *  Make an api call for fetching stats from the url
   *@returns {Observable<R>} returns Observable
   */
  get(url, params): Observable<any> {
    if (params == null) {
      return this.http.get(url)
        .map(this.extractData)
        .catch(this.handleError);
    }
    return this.http.get(url, {params: params})
      .map(this.extractData)
      .catch(this.handleError);
  }

  downLoad(url) {
    let headers = new HttpHeaders({
      'Content-Type': 'application/pdf'
    });
    return this.http.get(url, {responseType: 'blob', headers})
  }

  getHeaders(): HttpHeaders {
    let headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });

    return headers;
  }

  post(url, data): Observable<any> {
    return this.http.post(url, data)
      .map(this.extractData)
      .catch(this.handleError);
  }

  /**
   * @description extracts the data from observable
   * @param res Response of http
   * @returns {any|{}} return body if null returns blank object
   */
  private extractData(res: HttpResponse<any>) {
    let body = res;
    return body || {};
  }

  /**
   * In case of error in http it's get called to handle error throws error Observable
   * @param error error response
   * @returns {ErrorObservable}
   */
  private handleError(error: Response | any) {

    // In a real world app, we might use a remote logging infrastructure
    let errMsg: string;
    let body;
    if (error instanceof Response) {
      try {
        body = error.json() || '';
        const err = body.error || JSON.stringify(body);
        errMsg = `${err}`;
      } catch (err) {
        errMsg = DataConfig.exceptionMessage;
      }
    } else {
      errMsg = error.message ? error.message : error.toString();
    }
    return Observable.throw(errMsg);
  }

}
